<template>
  <span v-if="selector" :title="selector.description?selector.description:''">
    <span>&nbsp;</span>
        <span v-if="selector === 'any'">
          <b-badge pill :style="'background-color: ' + 'any_sel'.toHSL()">Any</b-badge>
        </span>
    <span
      v-else-if="selector === 'icmp'">
          <b-badge pill :style="'background-color: ' + 'icmp'.toHSL()">ICMP</b-badge>
    </span>
    <span
      v-else-if="selector === 'icmpv4'">
          <b-badge pill :style="'background-color: ' + 'icmpv4'.toHSL()">ICMPv4</b-badge>
    </span>
    <span
      v-else-if="selector === 'icmpv6'">
          <b-badge pill :style="'background-color: ' + 'icmpv6'.toHSL()">ICMPv6</b-badge>
    </span>
    <span v-else-if="typeof selector === 'string'">{{ selector }}</span>
    <span v-else-if="'macro' in selector">
      <b-badge pill :style="'background-color: ' + 'macro'.toHSL()">Macro</b-badge>
      <code>{{ selector.macro }}</code>
    </span>
    <span v-else-if="'selector_group' in selector">{{ selector.selector_group }}</span>
    <span v-else-if="'l4' in selector">
      <b-badge pill :style="'background-color: ' + 'l4'.toHSL()">L4</b-badge>
      Protocol:&nbsp;<code>{{ selector.l4 }}</code>
      <span v-if="selector.destination"> destination&nbsp;port&nbsp;{{ selector.destination }}</span>
        <span v-if="selector.source"> source&nbsp;port&nbsp;{{ selector.source }}</span>
      </span>
        <span v-else>{{ JSON.stringify(selector) }}</span>
  </span>
</template>

<script>

export default {
  name: 'FWMLv2SelectorViz',
  props: {
    selector: {
      type: Object,
      required: true
    }
  },
}
</script>
